var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.944 17.5717C14.744 19.3717 12.6011 20.5717 10.2868 20.5717C6.5154 20.5717 3.42969 17.486 3.42969 13.7146C3.42969 9.94314 6.5154 6.85742 10.2868 6.85742",
    stroke: "white",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.767 19.542C19.8812 17.9134 20.567 15.8563 20.567 13.7134C20.567 8.05631 15.9384 3.42773 10.2812 3.42773L10.2812 13.7134L18.767 19.542Z",
    stroke: "white",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.6f617b26d87adad8ca30415ccdb616b6.svg";
export { ForwardRef as ReactComponent };